/*
  Phase 4 API client — contextual memory + AI insights.
*/
import axios from "axios";
import { API, getClientId } from "./api";

const http = axios.create({ baseURL: API });
http.interceptors.request.use((cfg) => {
  cfg.headers["X-Client-Id"] = getClientId();
  return cfg;
});

export const phase4Api = {
  // Memory
  async timeline({ source, limit = 50 } = {}) {
    const params = {};
    if (source) params.source = source;
    if (limit) params.limit = limit;
    return (await http.get("/memory/timeline", { params })).data;
  },
  async search(query) {
    return (await http.post("/memory/search", { query })).data;
  },
  // Insights
  async listInsights({ includeDismissed = false, limit = 20 } = {}) {
    return (await http.get("/insights", {
      params: { include_dismissed: includeDismissed, limit },
    })).data;
  },
  async dismissInsight(id) {
    return (await http.patch(`/insights/${id}`)).data;
  },
  async deleteInsight(id) {
    return (await http.delete(`/insights/${id}`)).data;
  },
  async generateInsights() {
    return (await http.post("/insights/generate")).data;
  },
};
